import { RemoteFileLoader } from '@amzn/ihm-associate-tools-js-lib'
import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'

import { getSeawardIFrame } from '@atredux/selectors/iframeSelector'
import { store } from '@atredux/store'
import { getStoreInfo } from '@src/redux/selectors/storeSelector'

const VENDOR_CONFIG_URL = '/remote/ihm-associate-tools-menu/menu-config/mendel-vendor.json'

export async function getDefaultMenuConfig (): Promise<any> {
    const storeInfo = getStoreInfo(store.getState())

    if (!storeInfo) {
        console.log('SMP: Store info is undefined, cannot get menu config.')
        return []
    }

    const currentStoreType = storeInfo.isKitchen ? storeInfo.kitchenSite : storeInfo.storeFamily

    return CrossFrameUtils.sendMessageToOtherFrame({
        frame: getSeawardIFrame(store.getState())?.current?.contentWindow,
        message: {
            method: 'associateToolBaseMenuConfig',
            data: {
                action: 'getDefaultMenuConfig',
                storeInfo,
                currentStoreType,
            },
        },
    })
}

export async function getRoleBasedMenuConfigByStoreFamily (): Promise<any> {
    const storeInfo = getStoreInfo(store.getState())

    if (!storeInfo) {
        console.log('SMP: Store info is undefined, cannot get menu config.')
        return []
    }

    const storeFamily = storeInfo.isKitchen ? storeInfo.kitchenSite : storeInfo.storeFamily

    return CrossFrameUtils.sendMessageToOtherFrame({
        frame: getSeawardIFrame(store.getState())?.current?.contentWindow,
        message: {
            method: 'associateToolBaseMenuConfig',
            data: {
                action: 'getRoleBasedMenuConfigByStoreFamily',
                storeFamily,
            },
        },
    })
}

export async function get3pVendorConfig (): Promise<any> {
    return RemoteFileLoader.loadJson({ url: VENDOR_CONFIG_URL })
}
